































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import MultiSelect, { MultiSelectOption } from 'client-website-ts-library/components/MultiSelect.vue';
import { ListingFilter } from 'client-website-ts-library/filters';
import { ListingCategory, ListingStatus, PropertyType, WebsiteLevel } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';

@Component({
  components: {
    MultiSelect,
  },
})
export default class ListingSearch extends Vue {
  @Prop({ required: true })
  private readonly methodOfSale!: string;

  @Prop({ required: false })
  private readonly agentGuid!: string;

  private mos: string = this.methodOfSale;

  private filter: ListingFilter = new ListingFilter({
    Statuses: this.methodOfSale === 'sold' ? [ListingStatus.Sold] : [ListingStatus.Current, ListingStatus.UnderContract],
    PageSize: 9,
    SearchGuid: this.agentGuid || Config.API.WebsiteId,
    SearchLevel: this.agentGuid ? WebsiteLevel.Profile : Config.API.WebsiteLevel,
  });

  private suburbs: MultiSelectOption[] = [];

  private selectedSuburbs: MultiSelectOption[] = [];

  private propertyTypes: MultiSelectOption[] = [];

  private selectedPropertyTypes: MultiSelectOption[] = [];

  private beds = 0;

  private baths = 0;

  private minPrice = 0;

  private maxPrice = 0;

  private moneyFormatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0 });

  private prices = this.getPrices();

  mounted() {
    this.updateFilter();
    this.getPrices();
    this.getPropertyTypes();
  }

  @Watch('methodOfSale')
  updateMos() {
    this.mos = this.methodOfSale;
  }

  private updateSuburbsDebounce: number | undefined = undefined;

  getPrices() {
    const prices: number[] = [];
    let price = 50000;
    for (let i = 0; i < 18; i += 1) {
      prices.push(price);
      price += 25000;
    }
    for (let i = 0; i < 10; i += 1) {
      prices.push(price);
      price += 50000;
    }
    for (let i = 0; i < 10; i += 1) {
      prices.push(price);
      price += 100000;
    }
    for (let i = 0; i < 4; i += 1) {
      prices.push(price);
      price += 250000;
    }
    for (let i = 0; i < 4; i += 1) {
      prices.push(price);
      price += 500000;
    }
    for (let i = 0; i < 5; i += 1) {
      prices.push(price);
      price += 1000000;
    }
    prices.push(price);
    price += 2000000;
    prices.push(price);
    price += 3000000;
    prices.push(price);
    return prices;
  }

  asDollars(value: number) {
    return `$${value.toLocaleString()}`;
  }

  updateSuburbs() {
    clearTimeout(this.updateSuburbsDebounce);

    this.updateSuburbsDebounce = window.setTimeout(() => {
      const tmpFilter = new ListingFilter(this.filter);

      tmpFilter.Suburbs = [];

      API.Listings.GetSuburbs(tmpFilter).then((suburbs) => {
        this.suburbs = suburbs.map((suburb) => ({ Value: suburb, Label: suburb }));
      });
    }, 2000);
  }

  getPropertyTypes() {
    this.propertyTypes = [
      { Value: PropertyType.House.toString(), Label: 'House' },
      { Value: PropertyType.Apartment.toString(), Label: 'Apartment' },
      { Value: PropertyType.Unit.toString(), Label: 'Unit' },
      { Value: PropertyType.Townhouse.toString(), Label: 'Townhouse' },
      { Value: PropertyType.Villa.toString(), Label: 'Villa' },
      { Value: PropertyType.BlockOfUnits.toString(), Label: 'Block Of Units' },
      { Value: PropertyType.Studio.toString(), Label: 'Studio' },
      { Value: PropertyType.Retirement.toString(), Label: 'Retirement Living' },
      { Value: PropertyType.Acreage.toString(), Label: 'Acreage' },
      { Value: 'Land', Label: 'Land' },
    ];
  }

  @Watch('mos')
  @Watch('beds')
  @Watch('baths')
  @Watch('minPrice')
  @Watch('maxPrice')
  updateFilter() {
    switch (this.mos) {
      case 'buy':
        {
          const hasLand = this.selectedPropertyTypes?.some((s) => s.Value === 'Land') ?? false;

          if (this.selectedPropertyTypes && this.selectedPropertyTypes.length === 1 && hasLand) {
            this.filter.Categories = [ListingCategory.ResidentialLand];
          } else if (this.selectedPropertyTypes && this.selectedPropertyTypes.length > 1 && hasLand) {
            this.filter.Categories = [ListingCategory.ResidentialSale, ListingCategory.ResidentialLand, ListingCategory.Rural];
          } else if (this.selectedPropertyTypes?.some((s) => s.Value === '0')) {
            this.filter.Categories = [ListingCategory.ResidentialSale, ListingCategory.Rural];
          } else if (this.selectedPropertyTypes && this.selectedPropertyTypes.length === 1 && !hasLand) {
            this.filter.Categories = [ListingCategory.ResidentialSale, ListingCategory.Rural];
          } else {
            this.filter.Categories = [ListingCategory.ResidentialSale, ListingCategory.ResidentialLand, ListingCategory.Rural];
          }
        }
        break;
      case 'rent':
        this.filter.Categories = [ListingCategory.ResidentialRental];
        break;
      default:
        this.filter.Categories = [];
        break;
    }

    this.updateSuburbs();
    this.filter.Suburbs = this.selectedSuburbs.map((s) => s.Value);
    this.filter.PropertyTypes = this.selectedPropertyTypes.filter((t) => t.Value !== 'Land').map((s) => Number(s.Value));

    this.filter.MinBedrooms = this.beds;
    this.filter.MinBathrooms = this.baths;
    this.filter.MinPrice = this.minPrice;
    this.filter.MaxPrice = this.maxPrice;

    this.filter.Page = 1;

    this.emitFilter();
  }

  suburbsUpdated(selectedSuburbs: MultiSelectOption[]) {
    this.selectedSuburbs = selectedSuburbs;

    this.updateFilter();
  }

  propertyTypesUpdated(selectedPropertyTypes: MultiSelectOption[]) {
    this.selectedPropertyTypes = selectedPropertyTypes;
    this.updateFilter();
  }

  private emitDebounce: number | undefined = undefined;

  emitFilter() {
    this.$emit('filter_updated', this.filter);
  }
}
